import React from 'react';
import styles from './footer.module.scss';

const Footer = () => (
  <footer className={styles.footer}>
    <p>&copy; 2018 Maintained by <a href="https://brainhub.eu">Brainhub</a></p>
  </footer>
);

export default Footer;


// WEBPACK FOOTER //
// ./~/@brainhubeu/gatsby-docs-kit/src/components/footer/Footer.js